import reducer from "./reducer";

import * as authSelectors from "./selectors";
import * as authOperations from "./operations";
import * as authTypes from "./types";

export { authSelectors, authOperations, authTypes };

export default reducer;
